import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearBrandsActions, clearSelectedBrandAction, getBrandsActions } from '../../redux/actions/brandsActions';

const useFetchBrands = ({ unpaged = false }) => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.brands?.search);
  const brands = useSelector((state) => state.brands?.brands);
  const loading = useSelector((state) => state.brands?.loading);

  const fetchBrands = useCallback(async () => {
    await dispatch(getBrandsActions(search, unpaged));
  }, [search, unpaged, dispatch]);

  useEffect(() => {
    fetchBrands();
  }, [fetchBrands]);

  useEffect(() => {
    return () => {
      dispatch(clearBrandsActions());
      dispatch(clearSelectedBrandAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchBrands();
  };

  return { loading, brands, refresh };
};

export default useFetchBrands;
